<template>
    <v-dialog
        v-model="dialog"
        max-width="500"
        @keydown.esc="cancel"
        :persistent="processing"
    >
        <v-card>
            <v-card-title class="headline">
                {{ $t(`actions.${type}.changeReseller.title`) }}
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <p>{{ $t(`actions.${type}.changeReseller.text`) }}</p>
                <v-text-field
                    v-if="model"
                    label="Parceiro Atual"
                    v-model="model.reseller.trade_name"
                    readonly
                />

                <SearchModelInput
                    v-model="newReseller"
                    :model="resellerModel"
                    label="Parceiro Destino"
                    item-text="trade_name"
                />
            </v-card-text>
            <v-card-actions>
                <v-btn
                    class="col"
                    color="red darken-1"
                    text
                    @click="close"
                    :disabled="processing"
                >
                    {{ $t('actions.close') }}
                </v-btn>
                <v-divider vertical=""></v-divider>
                <v-btn
                    class="col"
                    color="green darken-1"
                    text
                    @click="perform"
                    :loading="processing"
                >
                    {{ $t(`actions.${type}.changeReseller.perform`) }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import SearchModelInput from '@/shared/inputs/SearchModelInput'
import Reseller from '@/models/Reseller'

export default {
    props: {
        type: {
            type: String,
            default: () => {
                return 'customer'
            },
        },
    },

    components: {
        SearchModelInput,
    },

    data() {
        return {
            dialog: false,
            model: undefined,
            processing: false,
            newReseller: null,
        }
    },

    watch: {
        dialog(value) {
            if (value) return
            this.model = undefined
            this.newReseller = null
        },
    },

    computed: {
        resellerModel() {
            return new Reseller()
        },
    },

    methods: {
        open(model) {
            this.dialog = true
            this.model = model
        },

        close() {
            this.model = undefined
            this.dialog = false
        },

        async perform() {
            this.processing = true

            let res = await this.model.changeReseller({
                reseller_id: this.newReseller.id,
            })

            this.processing = false
            this.dialog = false

            if (!res) return

            this.$emit('modelChanged')
            this.$bus.$emit(
                'notify',
                'success',
                this.$t(`actions.${this.type}.changeReseller.success`),
            )
        },
    },
}
</script>

<style></style>
